export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrowDownGrey.9d491be0.svg","height":6,"width":12,"blurWidth":0,"blurHeight":0};